import { Controller } from "@hotwired/stimulus"
import { searchPlants } from "../lib/plant_search"

// Server-side plant search with dropdown results (replaces Search.jsx + SearchView.jsx + SearchField.jsx + Store.js + Actions.js)
// Values: minimal (boolean), query, disableSuggestions (boolean)
// Targets: input, results
export default class extends Controller {
  static values = { minimal: Boolean, query: String, disableSuggestions: Boolean }
  static targets = ["input", "results"]

  connect() {
    if (this.queryValue) {
      this.inputTarget.value = this.queryValue
    }

    this._clickOutside = (e) => {
      if (!this.element.contains(e.target)) this.hideResults()
    }
    document.addEventListener("click", this._clickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._clickOutside)
  }

  focus() {
    if (this.inputTarget.value) this.search()
  }

  hideResults() {
    this.resultsTarget.innerHTML = ""
  }

  search() {
    // On the dedicated search results page the full result list is already
    // rendered below the input, so the floating typeahead dropdown is redundant
    // and would overlap (and on touch devices, intercept taps meant for) those
    // results. Suppress it there.
    if (this.disableSuggestionsValue) return

    const q = this.inputTarget.value

    if (q === "") {
      this.resultsTarget.innerHTML = ""
      return
    }

    searchPlants({ q, limit: 10 }).then((result) => {
      this.renderHits(result.hits, q)
    })
  }

  renderHits(hits, q) {
    if (hits.length === 0 && q) {
      this.resultsTarget.innerHTML = `<div class="dropdown input-search-result"><small>Nothing found. <a href="/plants/new">Add plant</a></small></div>`
      return
    }

    if (hits.length > 0) {
      this.resultsTarget.innerHTML = `<div class="dropdown">${hits.map(hit => this.renderHit(hit)).join("")}</div>`
    } else {
      this.resultsTarget.innerHTML = ""
    }
  }

  renderHit(plant) {
    const name = plant.type === "Variety" ? plant.parent_name + ' "' + plant.name + '"' : plant.name
    const title = name + " - " + plant.scientific_name + " (" + plant.type + ")"
    const tag = plant.type === "Variety"
      ? '<div class="tag-var">Variety</div>'
      : '<div class="tag-sp">Species</div>'

    const sizeClass = this.minimalValue ? "-sm" : ""
    return `<a data-turbo="false" class="input-search-result ${sizeClass}" href="${this.escapeHtml(plant.link)}" title="${this.escapeHtml(title)}">
      <img class="data-img-xs" src="${this.escapeHtml(plant.thumb || '/permapeople-permaculture-plant-database-blank.jpg')}" />
      <label class="input-search-result-name" style="margin-left:0.5rem"> ${this.escapeHtml(name)} ${tag}<span>${this.escapeHtml(plant.scientific_name)}</span></label>
    </a>`
  }

  submitSearch() {
    const q = this.inputTarget.value
    if (q) {
      Turbo.visit("/search?q=" + encodeURIComponent(q))
    }
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
